type FetchResult<T> = { data?: T; error?: unknown; response: Response }

export class ApiCallError extends Error {
  status: number
  code: string | null
  detail: unknown

  constructor(status: number, body: unknown) {
    const { code, detail } = (body ?? {}) as { code?: unknown; detail?: unknown }

    super(typeof detail === 'string' ? detail : `Request failed with status ${status}`)
    this.name = 'ApiCallError'
    this.status = status
    this.code = typeof code === 'string' ? code : null
    this.detail = detail
  }
}

// The typed client resolves with `{ data, error, response }` instead of throwing; mutations need a throw
export const unwrap = async <T>(request: Promise<FetchResult<T>>): Promise<T> => {
  const { data, error, response } = await request

  if (!response.ok) {
    throw new ApiCallError(response.status, error)
  }

  return data as T
}

export const bearer = (token: string) => ({ Authorization: `Bearer ${token}` })
